
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"49","height":"49","viewBox":"0 0 49 49","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M33.056 4.234c1.026 0 1.897.63 2.208 1.515l3.236 8.985v-.5l2.878-7.675a.5.5 0 01.468-.325h4.213a.5.5 0 01.496.438l.945 7.562v9a1 1 0 01-1 1h-3c0-3-2-5-5-5v7.5c0 .825-.7 1.5-1.556 1.5H35.39c-.856 0-1.556-.675-1.556-1.5v-1.5H15.167v1.5c0 .825-.7 1.5-1.556 1.5h-1.555c-.856 0-1.556-.675-1.556-1.5v-7.5c-3 0-5 2-5 5h-3a1 1 0 01-1-1v-9l.945-7.562a.5.5 0 01.496-.438h4.213a.5.5 0 01.468.325l2.878 7.675v.5l3.236-8.985a2.334 2.334 0 012.208-1.515h17.112zm-24.556 10l-2.386-6H4.266l-.766 6h5zm37 0l-.766-6h-1.848l-2.386 6h5zm-31.889 4.25c0 1.245 1.042 2.25 2.333 2.25 1.292 0 2.334-1.005 2.334-2.25s-1.042-2.25-2.334-2.25c-1.29 0-2.333 1.005-2.333 2.25zm17.111 0c0 1.245 1.042 2.25 2.334 2.25 1.29 0 2.333-1.005 2.333-2.25s-1.042-2.25-2.333-2.25c-1.292 0-2.334 1.005-2.334 2.25zm-14.778-12l-2.333 6.75H35.39l-2.333-6.75H15.944zM8.5 28.734c0 .326.044.639.127.934a1.463 1.463 0 00-.127.566c0 1.66 3.7 4.34 10 5.46v-5.46l8 8-8 8v-6.46c-8.12-1.28-14-5.06-14-9.54 0-2.25 1.489-4.327 4-5.998v4.498zm32 1.5c0-.177-.043-.367-.127-.566.083-.295.127-.608.127-.934v-4.498c2.511 1.671 4 3.748 4 5.998 0 4.1-4.94 7.62-12 9.16v-4.1c5.08-1.28 8-3.6 8-5.06z"}})])
          )
        }
      }
    